import { FieldProps } from '@rjsf/utils';
import { RelationBaseField } from './relation-base';
import { RelationPickerField } from './relation-picker';

export function RelationField({ uiSchema, ...rest }: FieldProps) {
  if (uiSchema?.['ui:widget'] === 'picker') {
    return <RelationPickerField uiSchema={uiSchema} {...rest} />;
  }

  return <RelationBaseField uiSchema={uiSchema} {...rest} />;
}
